export interface FlashMessageDto
{
    getId():string;
    getStatusMessage():string;
    getPlanName():string;
    getMsisdn():string;
    getIsAllCallers(): boolean;
    getDedicateFlashDtos(): DedicateFlashDto[];

    setId(id:string):void;
    setStatusMessage(statusMessage:string):void;
    setPlanName(planName:string):void;
    setMsisdn(msisdn:string):void;
    setIsAllCallers(allCallers: boolean): void;
    setDedicateFlashDtos(specialcallerMsisdn: DedicateFlashDto[]): void;
}

export class DedicateFlashDto
{
    constructor(private id: string, private flashName: string, private dedicateMsisdn: string, private statusMessage: string)
    {

    }

    getId(): string{
        return this.id;
    }

    getName(): string
    {
        return this.flashName;
    }

    getNumber(): string
    {
        return this.dedicateMsisdn;
    }

    getMessage(): string
    {
        return this.statusMessage;
    }
}

export class FlashMessageDtoImpl implements FlashMessageDto
{  
    private id :string;
    private statusMessage : string;
    private msisdn:string;
    private planName:string;
    private allCallers: boolean;
    private specialCallerMsisdn: DedicateFlashDto[] = [];

    getIsAllCallers(): boolean {
       return this.allCallers;
    }
    setIsAllCallers(allCallers: boolean): void {
        this.allCallers = allCallers;
    }
    getDedicateFlashDtos(): DedicateFlashDto[] {
        return this.specialCallerMsisdn;
    }
    setDedicateFlashDtos(specialcallerMsisdn: DedicateFlashDto[]): void {
       this.specialCallerMsisdn =specialcallerMsisdn;
    }

    getId(): string {
        return this.id;
    }
    getStatusMessage(): string {
        return this.statusMessage;
    }
    setId(id: string): void 
    {
        this.id = id;
    }
    setStatusMessage(statusMessage: string): void 
    {
        this.statusMessage = statusMessage;
    }
   
    getPlanName(): string 
    {
        return this.planName;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setPlanName(planName: string): void 
    {
        this.planName = planName;
    }
    setMsisdn(msisdn: string): void 
    {
        this.msisdn = msisdn;
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto.tsx